<clr-datagrid class="datagrid-compact" [clrDgRowSelection]="false">

  <clr-dg-action-bar>
    <a #download class="btn btn-sm btn-secondary" href="" (click)="downloadList()" download="products.csv">Свали
      списък</a>
  </clr-dg-action-bar>

  <clr-dg-column [clrDgField]="'product.PartNumber'">Продуктов код</clr-dg-column>
  <clr-dg-column [clrDgField]="'name'">Наименование</clr-dg-column>
  <clr-dg-column [clrDgField]="'quantity'">Количество</clr-dg-column>
  <clr-dg-column [clrDgField]="'availability'">Наличност</clr-dg-column>
  <!-- <clr-dg-column [clrDgField]="'product.MeasurementUnit.Code'">Мерна Единица</clr-dg-column> -->
  <clr-dg-column [clrDgField]="'product.ProductType.Name.BG'">Тип</clr-dg-column>
  <clr-dg-column [clrDgField]="'product.CustomProperty_StoreForProdOrder.Description.BG'">Склад</clr-dg-column>
  <clr-dg-column [clrDgField]="'level'">Ниво</clr-dg-column>

  <clr-dg-row *clrDgItems="let node of nodes" [clrDgItem]="node">
    <clr-dg-cell>{{node.product?.PartNumber}}</clr-dg-cell>
    <clr-dg-cell>{{node.name}}</clr-dg-cell>
    <clr-dg-cell>{{node.quantity | number: '1.0-5'}} &nbsp; {{node.product?.MeasurementUnit?.Code}}</clr-dg-cell>
    <clr-dg-cell>{{node.availability | number: '1.0-5'}} &nbsp; {{node.availabilityMeasure}}</clr-dg-cell>
    <!-- <clr-dg-cell>{{node.product?.MeasurementUnit?.Code}}</clr-dg-cell> -->
    <clr-dg-cell>{{node.product?.ProductType?.Name?.BG}}</clr-dg-cell>
    <clr-dg-cell>{{node.product?.CustomProperty_StoreForProdOrder?.Description?.BG}}</clr-dg-cell>
    <clr-dg-cell>{{node.level}}</clr-dg-cell>

    <ng-container ngProjectAs="clr-dg-row-detail">
      <clr-dg-row-detail *clrIfExpanded>
        <clr-datagrid style="width: 100%;">
          <clr-dg-column>Склад</clr-dg-column>
          <clr-dg-column>Партида</clr-dg-column>
          <clr-dg-column>Складово място</clr-dg-column>
          <clr-dg-column>Наличност</clr-dg-column>
          <clr-dg-column>Себестойност</clr-dg-column>

          <clr-dg-row *ngFor="let av of node.availabilityList">
              <clr-dg-cell>{{av.storeName}}</clr-dg-cell>
              <clr-dg-cell>{{av.lot}}</clr-dg-cell>
              <clr-dg-cell>{{av.storeBin}}</clr-dg-cell>
              <clr-dg-cell>{{av.total | number: '1.0-5'}} {{av.measure}}</clr-dg-cell>
              <clr-dg-cell>{{av.cost | number: '1.0-5'}} {{av.costCurrency}}</clr-dg-cell>
          </clr-dg-row>
      </clr-datagrid>
    </clr-dg-row-detail>
    </ng-container>

  </clr-dg-row>
</clr-datagrid>